/* eslint-disable max-len */
export const isCurrentDateEqualOrLessThanGivenDate = (givenDateString: string): boolean => {
    const currentDate = new Date();
    const [year, month, day, hours, minutes, seconds] = givenDateString.split(/[- :]/);
    const givenDate = new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds));

    const result = currentDate <= givenDate;
    return result;
};
